import { Text } from '@myinterview/component-library';
import i18n from 'i18next';
import React from 'react';
import { ANSWER_TYPES, ASSESSMENT_QUESTIONS_TYPE } from '../interfaces/jobInterface';

interface IProps {
  currentQuestionObj: ASSESSMENT_QUESTIONS_TYPE;
}

const INSTRUCTIONS: { [K in ASSESSMENT_QUESTIONS_TYPE['answerType']]: () => string } = {
  [ANSWER_TYPES.TEXT]: () => i18n.t('assessment.instructions.text'),
  [ANSWER_TYPES.SINGLE]: () => i18n.t('assessment.instructions.single'),
  [ANSWER_TYPES.MULTIPLE]: () => i18n.t('assessment.instructions.multi'),
};

export const AnswerInstructions:React.FC<IProps> = ({ currentQuestionObj }) => {
  const instructions = INSTRUCTIONS[currentQuestionObj.answerType]();
  return (
    <Text className="myinterview-widget-assessment__instructions" color="neutral-50" size="S-Regular">
      {instructions}
    </Text>
  );
};
